import {
  jobSummarySchema,
  type CreateJobInput,
  type JobListQuery,
  type JobSummary,
  type Page,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** Every jobs call the app makes. Components never touch fetch directly. */

export function fetchJobs(query: Partial<JobListQuery> = {}): Promise<Page<JobSummary>> {
  return fetchPage('/jobs', jobSummarySchema, query as Record<string, string | number | undefined>);
}

export function fetchMyJobs(query: Partial<JobListQuery> = {}): Promise<Page<JobSummary>> {
  return fetchPage(
    '/jobs/mine',
    jobSummarySchema,
    query as Record<string, string | number | undefined>,
  );
}

export async function fetchJob(jobId: string): Promise<JobSummary> {
  return jobSummarySchema.parse(await apiFetch<unknown>(`/jobs/${jobId}`));
}

export async function createJob(input: CreateJobInput): Promise<JobSummary> {
  return jobSummarySchema.parse(await post<unknown>('/jobs', input));
}

export async function publishJob(jobId: string): Promise<JobSummary> {
  return jobSummarySchema.parse(await post<unknown>(`/jobs/${jobId}/publish`, {}));
}
